import { useMutation } from '@tanstack/react-query';
import { dropCourse } from '../../../core/queries/course';

interface DropCourseParams {
  slug: string;
  reasons?: string[];
}

export function useDropCourse() {
  const { data, isError, error, isSuccess, isPending, mutate } = useMutation({
    mutationKey: ['course-drop'],
    mutationFn: ({ slug, reasons }: DropCourseParams) =>
      dropCourse(slug, reasons),
    retry: false
  });

  return {
    data,
    isError,
    isLoading: isPending,
    error,
    isSuccess,
    mutate,
  };
}
